import React, { useState, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CartContext } from "./CartContext";
import { useNavigate } from "react-router-dom";

const minOrderAmounts = {
  "Tamil Nadu": 3000,
  "Andhra Pradesh": 5000,
  "Telangana": 5000,
  "Karnataka": 5000,
};

const ConfirmationDetails = ({ isOpen, onClose }) => {
  const { cartItems, calculateOverallTotals } = useContext(CartContext);
  const { netTotal, youSave, overallTotal } = calculateOverallTotals() || {
    netTotal: 75.00,
    youSave: 60.00,
    overallTotal: 135.00,
  };
  const [formData, setFormData] = useState({
    state: "Tamil Nadu",
    city: "",
    name: "",
    mobile: "",
    email: "",
    address: "",
  });
  const [subTotal, setSubTotal] = useState(15.00); // Example from image
  const [packingCharges, setPackingCharges] = useState(0.00);
  const [overallAmount, setOverallAmount] = useState(15.00);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // Validate form data and submit logic here
    console.log("Form submitted:", formData);
    // Navigate to a success page or process order
    navigate("/success");
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ type: "spring", damping: 20, stiffness: 100 }}
          className="fixed top-0 right-0 w-full sm:w-96 h-full bg-white shadow-lg z-50 p-4 overflow-y-auto"
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-red-800">மகிழ்யா பட்டாசுகள்</h2>
            <button
              onClick={onClose}
              className="text-2xl text-red-600 hover:text-red-800"
              aria-label="Close details"
            >
              &times;
            </button>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-purple-800 text-white">
                    <th className="border p-2">Image</th>
                    <th className="border p-2">Code</th>
                    <th className="border p-2">Product Name</th>
                    <th className="border p-2">Content</th>
                    <th className="border p-2">Actual Price</th>
                    <th className="border p-2">Price</th>
                  </tr>
                </thead>
                <tbody>
                  {cartItems.map((item, index) => {
                    const { originalPrice, discountedPrice } = calculateOverallTotals(
                      item.rate || 0,
                      item.quantity || 0,
                      item.discount || 0
                    );
                    return (
                      <tr key={index} className="border">
                        <td className="border p-2">
                          <img src={item.image || "/placeholder.png"} alt={item.name} className="w-12 h-12" />
                        </td>
                        <td className="border p-2">{index + 1}</td>
                        <td className="border p-2">{item.name || "Unknown Item"}</td>
                        <td className="border p-2">{item.content || "10PCS"}</td>
                        <td className="border p-2">₹{originalPrice}</td>
                        <td className="border p-2">₹{discountedPrice}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="mt-4 space-y-2 text-lg font-semibold">
                <p>Net Total: ₹{netTotal.toFixed(2)}</p>
                <p>You Save: ₹{youSave.toFixed(2)}</p>
                <p>Overall Total: ₹{overallTotal.toFixed(2)}</p>
              </div>
            </div>
            <div>
              <div className="space-y-2">
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  aria-label="Select state"
                >
                  {Object.keys(minOrderAmounts).map((region) => (
                    <option key={region} value={region}>
                      {region}
                    </option>
                  ))}
                </select>
                <select
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  aria-label="Select city"
                >
                  <option value="">Select City</option>
                  {/* Add city options dynamically based on state */}
                </select>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  className="w-full p-2 border rounded"
                  aria-label="Enter name"
                />
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Mobile No"
                  className="w-full p-2 border rounded"
                  aria-label="Enter mobile number"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full p-2 border rounded"
                  aria-label="Enter email"
                />
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Address"
                  className="w-full p-2 border rounded"
                  aria-label="Enter address"
                />
                <div className="mt-4 space-y-1 text-lg">
                  <p>Sub Total: ₹{subTotal.toFixed(2)}</p>
                  <p>Packing Charges (%): ₹{packingCharges.toFixed(2)}</p>
                  <p>Round Off: ₹0.00</p>
                  <p>Overall Amount: ₹{overallAmount.toFixed(2)}</p>
                </div>
                <div className="mt-4 space-x-2">
                  <button
                    onClick={handleSubmit}
                    className="w-1/2 bg-green-500 text-white p-2 rounded hover:bg-green-600"
                  >
                    Submit
                  </button>
                  <button
                    onClick={onClose}
                    className="w-1/2 bg-red-500 text-white p-2 rounded hover:bg-red-600"
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationDetails;